import { useCallback } from 'react';

export const useScroll = (container: Window | HTMLDivElement = window) => {
  const scrollTo = useCallback(
    (element: HTMLDivElement, { offset = 0, behavior = 'smooth' }) => {
      container.scrollTo({
        behavior,
        top:
          element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
      });
    },
    [container],
  );

  return { scrollTo };
};
